import { getAPIUrl } from '../global';
import { Get, Post, Put, Remove } from '../headerIntercepter';

export const login = (data) => {
  const url = getAPIUrl('auth.login');
  return Post(url, data, false);
};